<template>
  <label class="construct-form-file-container">
    <input type="file" ref="inputFile" :name="inputName" @change="onChange" :accept="accept">
    <div v-if="!is_uploaded" class="construct-form-file-button"><span>Прикрепить</span></div>
  </label>

  <div v-if="is_uploaded" class="construct-form-file-has-uploaded">
    <div class="construct-form-file-has-uploaded__icon">
      <img src="/assets/images/icons/file_icon.svg">
    </div>
    <div class="construct-form-file-has-uploaded__title">Документ добавлен</div>
    <div class="construct-form-file-has-uploaded__remove" @click.prevent="clear">Удалить</div>
  </div>

  <div class="site-form-error p-0 mt-1" v-if="errorMessage">{{ errorMessage }}</div>

</template>

<script>
export default {
  name: "file",
  data() {
    return {
      is_uploaded: false,
      value: null,
    };
  },
  props: {
    accept: {
      type: [String, null],
      default: '*/*'
    },
    name: {
      type: [String, null],
      required: true,
      default: null
    },
    customName: {
      type: String,
      default: null
    },
  },
  inject: ['errors', 'formKey'],
  computed: {
    inputName: function () {
      return this.customName ? `${this.formKey}${this.customName}` : `${this.formKey}[${this.name}]`;
    },
    errorMessage: function () {
      const errors = this.errors[this.name];
      return errors ? errors.join('') : null;
    }
  },
  methods: {
    onChange(event) {
      this.is_uploaded = event.target.files.length > 0;
      this.$emit('update:modelValue', event.target.files[0] ?? null);
      this.$nextTick(() => this.$refs.inputFile.value = null)
    },
    clear() {
      this.$emit('update:modelValue', null);
      this.is_uploaded = false;
    }
  }
}
</script>
